<template>
  <div class="page form_page js_show">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">门店老板注册</h2>
        <div class="weui-form__desc">门店老板信息注册,注册完成后可以查看到自己关联的门店数据,请确保你的注册手机号与门店注册中手机号一致</div>
      </div>
      <div class="weui-form__control-area">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
              <div class="weui-cell__bd">
                <input id="js_input" class="weui-input" placeholder="填写门店注册时手机号">
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd"><label class="weui-label">名称</label></div>
              <div class="weui-cell__bd">
                <input id="js_input" class="weui-input" placeholder="请填写你本人名称">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="weui-form__opr-area">
        <a class="weui-btn weui-btn_primary" href="javascript:" id="showTooltips">确定</a>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "wetest.vue"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Register/wetest.vue